import { getCurrentProduct } from 'utils';
import { Product } from './getCurrentProduct';

const currentProduct = (): Product | undefined => {
  const curentProduct = getCurrentProduct();
  return curentProduct;
};

export default currentProduct;
